import { capitalize } from '../../util/helpers/Strings';

export const resourceNameDisplay = resource => (
  resource.resourceName ?
    resource.resourceName :
    `${capitalize(resource.resourceType)} Resource`
);

export const iconSlugFromResourceType = (resourceType) => {
  switch (resourceType) {
    case 'database':
      return 'database';
    case 'google sheets':
      return 'google';
    case 'github':
      return 'github';
    default:
      return 'globe';
  }
};
